import React from "react";
import { Box, Text } from "grommet";

const TONES = {
    live: { background: "status-live", color: "#04170f" },
    editing: { background: "active", color: "white" },
    retired: { background: "status-retired", color: "#13162b" },
    deleted: { background: "status-critical", color: "white" },
    neutral: { background: "surface-hover", color: "white" },
};

const Badge = ({ tone = "neutral", children }) => {
    const { background, color } = TONES[tone] || TONES.neutral;
    return (
        <Box
            background={background}
            round="large"
            pad={{ horizontal: "small", vertical: "2px" }}
            flex={false}
        >
            <Text size="xsmall" weight="bold" color={color}>
                {children}
            </Text>
        </Box>
    );
};

export { Badge };
